import { Box, Grid, Heading, Text } from '@chakra-ui/react'
import { Section } from '@/components/layout'
import { SectionLabel } from '@/components/typography'
import { useLocale } from '@/i18n'
import { padNumber } from '@/lib/padNumber'
import { AUDIT_HOOK, PATTERNS_INTRO, PROBLEM_PATTERNS, WHERE_AI_LABEL } from './problems.data'

export const WhereAIPaysOff = () => {
  const { locale } = useLocale()

  return (
    <Section id="ai">
      <SectionLabel mb="32px">{WHERE_AI_LABEL[locale]}</SectionLabel>
      <Text
        mb="48px"
        fontFamily="heading"
        fontWeight="800"
        fontSize="clamp(24px, 2.4vw, 38px)"
        lineHeight="1.18"
        letterSpacing="-0.025em"
        maxW="30ch"
      >
        {PATTERNS_INTRO[locale]}
      </Text>
      <Grid
        templateColumns="repeat(auto-fit, minmax(min(320px, 100%), 1fr))"
        columnGap="clamp(32px, 4vw, 64px)"
      >
        {PROBLEM_PATTERNS[locale].map((pattern, index) => (
          <Grid
            key={pattern.title}
            borderTop="2px solid"
            borderColor="divider"
            pt="20px"
            pb="24px"
            templateColumns="clamp(38px, 5vw, 56px) minmax(0, 1fr)"
            gap="clamp(10px, 1.4vw, 16px)"
          >
            <Text
              fontFamily="heading"
              fontWeight="800"
              fontSize="22px"
              color="accent"
              letterSpacing="-0.01em"
            >
              {padNumber(index)}
            </Text>
            <Box>
              <Heading as="h4" fontSize="19px" fontWeight="800" letterSpacing="-0.015em">
                {pattern.title}
              </Heading>
              <Text mt="8px" fontSize="15px" lineHeight="1.62" color="muted">
                {pattern.line}
              </Text>
            </Box>
          </Grid>
        ))}
      </Grid>
      <Text
        mt="32px"
        pt="20px"
        borderTop="2px solid"
        borderColor="divider"
        fontSize="15px"
        lineHeight="1.62"
        maxW="82ch"
        color="muted"
      >
        {AUDIT_HOOK[locale]}
      </Text>
    </Section>
  )
}
